import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=52dcca04&scoped=true&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"
import style0 from "./Error.vue?vue&type=style&index=0&id=52dcca04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dcca04",
  null
  
)

export default component.exports